<template>
  <!-- 참조: https://19-97.tistory.com/128 -->
  <LineChartGenerator
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator
  },
  // props:["week"],
  props: {
    chartId: {
      type: String,
      default: 'line-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    },
    week: {
      type: Array,
      default: () => []
    },
    scoreArr: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartData: {
        // labels: ['일','월','화','수','목','금','토'],
        labels: [],
        datasets: [
          {
            backgroundColor: '#7260FF',
            // data: [2, 6, 1, 5, 6, 10, 5],
            data: [],
            radius: 4,
            clip: {
              left: 5,
              top: false,
              right: 5,
              bottom: 5
            }
          }
        ]
      },
      chartOptions: {
        showLine: false,
        responsive: true,
        maintainAspectRatio: false, // 가로세로 비율
        scales: {
              x: {
                  grid: {
                      display: false, // 세로줄 제거
                  },
              },
              y: {
                    beginAtZero: true,  // 0부터 시작
                    min: 0,
                    max: 10,
                    grid: {
                        display: true,
                    },
                    ticks:{
                      stepSize : 2,
                    }
              },
        }
      }
    }
  },
  mounted() {

    // console.log("this.chartData.labels : ", this.chartData.labels)
    this.chartData.labels = this.week
    // console.log("this.scoreArr : ", this.scoreArr)
    // console.log("this.chartData.datasets.data : ", this.chartData.datasets[0].data)
    this.chartData.datasets[0].data = this.scoreArr

  },
}
</script>
